module.exports = __webpack_public_path__ + "img/squares.899e1784.gif";